import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {CustomDropDownComponent} from "../drop-down/custom-drop-down.component";
import {useServices} from "../../hooks/use-services.hook";
import {FlightDatesDropDownListComponent} from "./list/flight-dates-drop-down-list.component";
import {FlightsDatesSelector} from "../../services/flight-search/dates-selection/flights-dates-selector";
import {IDropDownController} from "../drop-down/drop-down-controller.interface";
import {FlightDatesDropdownPcHeaderComponent} from "./header/flight-dates-dropdown-pc-header.component";
import {CalendarIcon} from "../../assets/svg/calendar.icon";


export const FlightDatesDropDownComponent: React.FC = observer(() => {
    const services = useServices();
    const searchController = services.flightSearch.searchController;
    const [datesSelector] = useState(new FlightsDatesSelector(searchController, services));

    useEffect(() => {
        return () => {
            datesSelector.dispose();
        };
    }, [datesSelector]);

    const renderInput = (dropDownController: IDropDownController) => {
        return (
            <FlightDatesDropdownPcHeaderComponent datesSelector={datesSelector} dropDownController={dropDownController}/>
        );
    }

    const renderList = (dropDownController: IDropDownController) => {
        return (
            <FlightDatesDropDownListComponent datesSelector={datesSelector} dropDownController={dropDownController}/>
        )
    }

    const onDropDownOpen = () => {
    }

    const onDropDownClose = () => {
    }

    const label = searchController.isOneWay
                        ? services.language.translate('Departure date')
                        : services.language.translate('Flights dates')



    return (
        <CustomDropDownComponent label={label}
                                 icon={<CalendarIcon/>}
                                 errorMessage={searchController.fields.departureDate.error || searchController.fields.returnDate.error}
                                 renderInput={renderInput}
                                 renderList={renderList}
                                 onOpen={onDropDownOpen}
                                 onClose={onDropDownClose}/>
    )
});
